import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDislikeOp, getOptions, getCommission } from '../../Apis/content';

export const Options = createAsyncThunk('Options', async (_, { rejectWithValue }) => {
    try {
        const response = await getOptions();
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const Listdislike = createAsyncThunk('Listdislike', async (_, { rejectWithValue }) => {
    try {
        const response = await getDislikeOp();
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const CommisinPrice = createAsyncThunk('CommisinPrice', async (formData, { rejectWithValue }) => {
    try {
        const response = await getCommission(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
})

const curencyOpSlice = createSlice({
    name: 'currOption',
    initialState: {
        error: null,
        success: false,
        currecnyList: [],
        hourList: [],
        fixedList: [],
        list: [],
        comission: {}
    },
    reducers: {
        clearCurrOptatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(Options.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Options.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.currecnyList = action.payload.data.currency;
                state.hourList = action.payload.data.client_payment_options.per_hour;
                state.fixedList = action.payload.data.client_payment_options.fixed;
            })
            .addCase(Options.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(Listdislike.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Listdislike.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.list = action.payload.data.data;
            })
            .addCase(Listdislike.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(CommisinPrice.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(CommisinPrice.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.comission = action.payload.data.data;
            })
            .addCase(CommisinPrice.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

    },

});
export const { clearCurrOptatus } = curencyOpSlice.actions;
export default curencyOpSlice.reducer;

